'use strict';

var { processInclude } = require('./utils/helpers');

$(document).ready(function () {
    processInclude(require('./components/video'));
});
